import { Suspense, useContext, useEffect } from "react";
import { Navigate, Route, Routes, useParams } from "react-router-dom";
import Loader from "../layout/loader";
import Login from "../pages/auth/login";
import LayoutRoutes from "./layout-routes";
import PrivateRouteCheck from "./private-route-check";
import useGetAuthStaffUserV2 from "../hooks/use-get-authuser";
import { UploadProgressProvider } from "../context/UploadProgressContext";
import Spinner from "../components/common/Spinner";
import { AuthStaffUserContext } from "../context/AuthStaffUserContext";
const Routers = () => {
  const params = useParams();

  const { setuserPermission } = useContext(AuthStaffUserContext);
  // const jwtToken = localStorage.getItem("token");

  const {
    data: staffAuthData,
    isLoading: staffAuthLoading,
    // isError: staffAuthError,
  } = useGetAuthStaffUserV2();

  useEffect(() => {
    if (!staffAuthLoading && staffAuthData) {
      let permission: Record<string, { read: boolean; write: boolean }> = {};
      staffAuthData.result.data.department.accessPages.map((page) => {
        permission[page.name] = { read: page.read, write: page.write };
      });
      setuserPermission(permission);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [staffAuthData, staffAuthLoading]);

  const navigateTo = staffAuthData?.result.data.department.accessPages[0].name;

  if (staffAuthLoading) {
    return <Spinner fullScreenOverlay />;
  }

  return (
    <Suspense fallback={<Loader />}>
      <UploadProgressProvider>
        <Routes>
          <Route
            path={"/"}
            // element={<PrivateRoute />}
          >
            {staffAuthData ? (
              <>
                <Route
                  path={`${process.env.PUBLIC_URL}`}
                  element={
                    <Navigate
                      to={
                        navigateTo === "tvapp"
                          ? `${process.env.PUBLIC_URL}/${params.hotelcode}/tv-app/room/lights`
                          : `${process.env.PUBLIC_URL}/${params.hotelcode}/${navigateTo}`
                      }
                    />
                  }
                />
              </>
            ) : (
              <Route
                path={`${process.env.PUBLIC_URL}`}
                element={
                  <Navigate
                    to={`${process.env.PUBLIC_URL}/${params.hotelcode}/login`}
                  />
                }
              />
            )}
            <Route
              path={`/*`}
              element={
                <PrivateRouteCheck>
                  <LayoutRoutes
                    accessPages={
                      staffAuthData?.result.data.department.accessPages
                    }
                  />
                </PrivateRouteCheck>
              }
            />
          </Route>
          {/* <Route
                  path={`${process.env.PUBLIC_URL}/callback`}
                  render={() => <Callback />}
                /> */}
          <Route
            // exact
            path={`${process.env.PUBLIC_URL}/login`}
            element={<Login />}
          />
          {/* {authRoutes.map(({ path, Component }, i) => (
                  <Route path={path} element={Component} key={i} />
                ))} */}
        </Routes>
      </UploadProgressProvider>
    </Suspense>
  );
};
export default Routers;
